import './styles.css';

import {
  ApiProvider,
  AuthProvider,
  createApiClient,
  createAuthStore,
  createQueryClient,
  I18nProvider,
  initSentry,
} from '@classgo/app-kit';
import { ToastProvider } from '@classgo/ui';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { cognito } from './cognito';
import { config } from './config';
import { messages } from './i18n';
import { createAppRouter } from './router';

void initSentry(config.sentry);
const auth = createAuthStore({ backend: cognito, storage: window.sessionStorage });
const api = createApiClient({
  baseUrl: config.apiUrl,
  getToken: auth.getIdToken,
  onUnauthorized: () => auth.signOutLocal('expired'),
  getActAsSession: auth.getActAsSession,
});
const queryClient = createQueryClient();
const router = createAppRouter({ auth, api, queryClient });

const root = document.getElementById('root');
if (!root) {
  throw new Error('Missing #root element');
}
createRoot(root).render(
  <StrictMode>
    <I18nProvider messages={messages}>
      <ToastProvider>
        <AuthProvider store={auth} cognito={cognito}>
          <ApiProvider client={api} queryClient={queryClient}>
            <RouterProvider router={router} />
          </ApiProvider>
        </AuthProvider>
      </ToastProvider>
    </I18nProvider>
  </StrictMode>,
);
